
<div class="input-group" >
  <input
    class="form-control"
    placeholder="{{ placeholder }}"
    name="dp"
    ngbDatepicker
    #d="ngbDatepicker"
    [(ngModel)]="model"
    (dateSelect)="onDateSelection($event)"
  />
  <div class="input-group-append">
    <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d.toggle()" type="button"></button>
  </div>
</div>
